import React from 'react';
import { useNavigate } from 'react-router-dom';

import { List } from '@common/typescript/objects/List';

import { rest } from '@app/components/Api';
import {
	appointmentInformation2,
	euthanasiaEmbedText,
	euthanasiaFiftyText,
	euthanasiaFiftyTitle,
	euthanasiaLinkItems,
	euthanasiaServices,
	euthanasiaServicesTitle,
} from '@app/components/Pages/Services/Euthanasia/euthanasiaContent';
import EuthanasiaSlider from '@app/components/Pages/Services/Euthanasia/EuthanasiaSlider';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import FaqBlockHeader from '@app/components/UI/FaqBlock/FaqBlockHeader';
import FiftyFifty from '@app/components/UI/FiftyFifty/FiftyFifty';
import GetInTouchButton from '@app/components/UI/Forms/GetInTouch/GetInTouchButton';
import LinkBlockSmall from '@app/components/UI/LinkBlock/LinkBlockSmall';
import Masthead from '@app/components/UI/MastHead/Masthead';
import RichText from '@app/components/UI/RichText/RichText';
import SloganBlockSmall from '@app/components/UI/SloganBlock/SloganBlockSmall';
import VideoEmbed from '@app/components/UI/VideoEmbed/VideoEmbed';
import euthanasia from '@app/images/content/euthanasia.jpg';
import inHomeEuthanasia from '@app/images/content/In-home-euthanasia-lap-of-love.jpg';
import { Questions } from '@app/objects/Questions';
import HelmetProvider from '@app/providers/HelmetProvider/HelmetProvider';
import '@app/scss/components/ourServices.scss';

const Euthanasia = () => {
	const [questions, setQuestions] = React.useState<Array<Questions>>([]);
	const navigate = useNavigate();

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/euthanasiaPage').then((res) => setQuestions(res.list));
	}, []);

	return (
		<HelmetProvider>
			<div className="in-home-euthanasia our-services">
				<Masthead
					title="In-Home Pet Euthanasia"
					imageSrc={euthanasia}
					text="At some point, we move from ensuring a quality of life to ensuring a quality of death."
					quoteAuthor="Dr. Mary Gardner"
					imageAlt="In-home pet euthanasia"
				/>
				<VideoEmbed
					text={euthanasiaEmbedText}
					videoSrc="https://player.vimeo.com/video/218718960?color=ed261f&title=0&byline=0&portrait=0"
					videoTitle="See how we’ve helped our families."
				/>
				<FiftyFifty
					title={euthanasiaFiftyTitle}
					text={euthanasiaFiftyText}
					src={inHomeEuthanasia}
					alt="In-home euthanasia Lap of Love"
				/>
				<RichText title={euthanasiaServicesTitle} text={euthanasiaServices} />
				<SloganBlockSmall
					title="Need to talk to someone about in-home euthanasia?"
					btnText={(
						<>
							<a className="btn btn-primary visible-mobile" href="tel:855-933-5683">
								Call Us
							</a>
							<GetInTouchButton btnText="Schedule Appointment" btnClassName="btn btn-primary no-visible-mobile" />
						</>
					)}
					onBtnClick={() => {}}
					styled="slogan-block-small_white"
				/>

				<EuthanasiaSlider />

				<RichText title="" text={appointmentInformation2} />
				<SloganBlockSmall
					title="Looking for in-home pet euthanasia in your area?"
					btnText="Find a vet near you"
					onBtnClick={() => {
						navigate('/find-a-vet');
					}}
					styled="slogan-block-small_white"
				/>

				{/* classes should be fixed */}
				<div className="care-coordinator__faq">
					<div className="care-coordinator__faq-content">
						<FaqBlockHeader title="You might find yourself asking..." btnText="View all FAQ" clickUrl="/faq" />
						<FaqBlock questions={questions} />
					</div>
				</div>
				<LinkBlockSmall items={euthanasiaLinkItems} />
			</div>
		</HelmetProvider>
	);
};

export default Euthanasia;
